import axios from "axios";
import store from "@/store";
import { getToken } from "@/utils/auth";

const service = axios.create({
    baseURL: process.env.VUE_APP_KW_AUTH_BASE_URL,
    // baseURL: "",
    timeout: 50000
});

// 请求拦截器
service.interceptors.request.use(
    (config) => {
        config.headers["userId"] = getToken();
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    (response) => {
        const res = response.data;
        if (Number(res.code) === 200) {
            return res;
        }
        return Promise.reject(res);
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default service;
